import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'

export type VitalParametersIconProps = SvgIconProps

export function VitalParametersIcon(props: VitalParametersIconProps) {
  const { htmlColor } = props
  const theme = useTheme()
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Vital_parameters">
        <g>
          <g id="XMLID_00000138568791040051737220000011485998617422104457_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M158.245,98.704c-0.16,4.17,0.34,7.63,0.34,7.63L158.245,98.704z M113.485,98.914
					c-0.24,4.05,0,7.42,0,7.42V98.914z M114.475,134.124l0.48-19.1C114.955,115.024,114.335,124.324,114.475,134.124z
					 M181.005,43.214v113.57c0,8.21-6.66,14.87-14.88,14.87H33.875c-8.22,0-14.87-6.66-14.87-14.87V43.214
					c0-8.21,6.65-14.87,14.87-14.87h132.25C174.345,28.344,181.005,35.004,181.005,43.214z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M33.875,180.654c-13.16,0-23.87-10.71-23.87-23.87V43.214c0-13.16,10.71-23.87,23.87-23.87h132.25
					c13.17,0,23.88,10.71,23.88,23.87v113.57c0,13.16-10.71,23.87-23.88,23.87H33.875z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M166.125,171.654H33.875c-8.22,0-14.87-6.66-14.87-14.87V43.214c0-8.21,6.65-14.87,14.87-14.87h132.25
					c8.22,0,14.88,6.66,14.88,14.87v113.57C181.005,164.994,174.345,171.654,166.125,171.654z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M31.455,49.784h9.02l2.31,3.15l2.94-2.94c0,0,2.54-0.6,2.54-1.86l1.1,22.58l1.1-25.81c0,0-0.23,4.17,1.81,4.96
					c2.05,0.79,7.16,0.47,10.7,7.94c0,0,2.28-7.55,4.41-8.73c2.12-1.18,5.98-1.34,8.34,2.83c0,0,1.73-4.24,4.8-4.56
					c0,0,1.65,9.83,2.2,23.84l0.55-26.28c0,0,1.34,2.52,1.26,4.01c0,0,6.68-3.3,11.33,8.34c0,0,1.1-7.47,4.16-7.63
					c3.07-0.15,5.28-1.81,7.56,3.15c0,0,0.08-3.75,4.64-4.31l1.73,22.72l0.94-26.28l1.58,5.04c0,0,6.92-2.99,10.69,8.1
					c0,0,1.74-8.1,4.25-8.57c2.52-0.48,17.62,0,17.62,0l2.99,3.77c0,0,1.89-4.09,5.35-4.25h10.02"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M158.245,98.704c0.24-6.24,1.98-14.06,9.15-14.19"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M158.245,98.704l0.34,7.63C158.585,106.334,158.085,102.874,158.245,98.704z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M113.485,98.914c0.39-6.62,2.07-15.07,8.18-13.77c9.86,2.1,13.21,0.63,13.21,0.63l7.98,1.26h5.66l3.15,1.25l2.72-2.3l2.99-7.14
					l0.87,19.86"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M113.485,98.914v7.42C113.485,106.334,113.245,102.964,113.485,98.914z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M31.455,86.404h14.9l2.1-6.93l1.25,24.97c0,0-0.42-17.83,4.62-18.88c5.03-1.05,10.07,1.47,10.07,1.47l9.02-2.1l3.15,2.93
					l3.98-2.93v-6.92c0,0,1.05,27.48,1.68,27.27c0.63-0.21-3.78-19.51,3.15-20.56c6.92-1.05,20.14,0.21,20.14,0.21l2.3,1.47
					l3.99-1.05l1.68-6.3v19.86"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M158.165,115.024l-0.02,1.22c0,0.05,0,0.11,0,0.17l-0.01,0.81c-0.08,8.5-0.19,38.74,2.34,38.92c2.93,0.21,6.92-2.73,6.92-2.73"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M152.715,150.684c0,0,0,0.01-0.01,0.02c-0.06,0.32-0.86,4.45,3.57,5.86l1.1,9.02l0.76-48.36"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M114.475,134.124c0.19,12.98,1.72,26.83,7.82,20.97l4.82-8.39l5.04,10.07h16.78l3.77-6.07"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M114.475,134.124l0.48-19.1C114.955,115.024,114.335,124.324,114.475,134.124z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor === theme.palette.primary.main ? '#ffffff' : '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M31.455,154.674l8.39,1.89l3.36-4.2l2.1,4.2h2.94l1.04,6.5l1.05-45.94l1.26,37.97c0,0,7.76,3.56,11.54-7.76
					c0,0,2.1,8.18,5.24,9.86c3.15,1.67,7.35-4.2,7.35-4.2s2.3,5.04,5.45,5.66l1.68,5.46v-45.73c0,0,0.63,39.86,3.15,39.86
					c2.51,0,10.69-9.65,10.69-9.65s-0.83,9.23,5.04,9.44c5.87,0.21,6.08-6.93,6.08-6.93s1.26,6.3,4.41,6.3l1.47,8.18l0.78-31.46"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default VitalParametersIcon
